export default __webpack_public_path__ + "static/media/history_1950_03.f95a7d16.png";